<template>
  <div class="images">
    <label
      for="uploadImage"
      class="images__btn mb12"
      :class="{
              images__btn_adaptive: data.images.src.length > 0,
              mr24: data.images.src.length > 0,
            }"
    >
      <input
        @change="uploadImage($event)"
        type="file"
        id="uploadImage"
        ref="uploadImage"
        style="display:none"
        multiple
      />

      <span
        class="images__container"
        :class="{
                images__container_adaptive: data.images.src.length > 0,
              }"
      >
        <svg
          class="images__img"
          width="60"
          height="60"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <ellipse cx="30" cy="30" rx="30" ry="30" fill="#F6F6F6" />

          <path
            d="M33.9986 44.2012H21.3135C16.8952 44.2012 13.3135 40.6195 13.3135 36.2012V23.7988C13.3135 19.3805 16.8952 15.7988 21.3135 15.7988H40.8164C45.2347 15.7988 48.8164 19.3806 48.8164 23.7988V30.8886"
            stroke="#F07300"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M36.0957 29.9144C36.0957 33.2837 33.3644 36.015 29.9951 36.015C26.6259 36.015 23.8945 33.2837 23.8945 29.9144C23.8945 26.5452 26.6259 23.8138 29.9951 23.8138C33.3644 23.8138 36.0957 26.5452 36.0957 29.9144Z"
            stroke="#F07300"
            stroke-width="2"
          />

          <mask id="path-4-inside-1" fill="white">
            <ellipse cx="41.9729" cy="22.5572" rx="1.62544" ry="1.62544" />
          </mask>

          <path
            d="M41.5983 22.5572C41.5983 22.3503 41.766 22.1826 41.9729 22.1826V26.1826C43.9751 26.1826 45.5983 24.5595 45.5983 22.5572H41.5983ZM41.9729 22.1826C42.1797 22.1826 42.3474 22.3503 42.3474 22.5572H38.3474C38.3474 24.5595 39.9706 26.1826 41.9729 26.1826V22.1826ZM42.3474 22.5572C42.3474 22.7641 42.1797 22.9318 41.9729 22.9318V18.9318C39.9706 18.9318 38.3474 20.5549 38.3474 22.5572H42.3474ZM41.9729 22.9318C41.766 22.9318 41.5983 22.7641 41.5983 22.5572H45.5983C45.5983 20.5549 43.9751 18.9318 41.9729 18.9318V22.9318Z"
            fill="#F07300"
            mask="url(#path-4-inside-1)"
          />
          <path
            d="M44.5722 35.6493V44.0698"
            stroke="#F07300"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M48.679 39.945H40.2952"
            stroke="#F07300"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <p class="images__content">
          <span class="images__title">{{ $t("forms.fotoUpload") }}</span>
          <span
            :class="{
                    'images__content-text_adaptive': data.images.src.length > 0,
                  }"
          >{{ $t("forms.fotoUploadText") }}</span>
        </p>
      </span>
    </label>

    <template v-if="data.images.src.length > 0">
      <div class="images__item mr24 mb12" v-for="item in data.images.src" :key="item.id">
        <img :src="item.src" width="120px" height="120px" />
        <img
          @click="deleteImage(item.id)"
          class="images__item_delete"
          src="@/assets/images/deletePhoto.svg"
          alt
        />
      </div>
    </template>

    <template v-if="data.files.src.length > 0">
      <div class="files__item" v-for="item in data.files.src" :key="item.id">
        <p>{{item.src}}</p>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imagesIndex: 100,
      filesIndex: 200,
      data: {
        images: {
          src: [],
          blob: []
        },
        files: {
          src: [],
          blob: []
        }
      }
    };
  },
  methods: {
    uploadImage(e) {
      const files = Array.from(e.target.files);

      files.forEach(file => {
        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = () => {
          if (file.type.includes("image")) {
            this.data.images.blob.push({
              id: this.imagesIndex,
              file
            });

            this.data.images.src.push({
              id: this.imagesIndex,
              src: reader.result
            });
            this.imagesIndex++;
            this.$emit("onChange", {
              images: this.data.images.blob,
              files: this.data.files.blob
            });
          } else {
            this.data.files.blob.push({
              id: this.filesIndex,
              file
            });

            this.data.files.src.push({
              id: this.filesIndex,
              src: file.name
            });
            this.filesIndex++;

            this.$emit("onChange", {
              images: this.data.images.blob,
              files: this.data.files.blob
            });
          }
        };
      });

      this.$refs["uploadImage"].value = "";
    },
    deleteImage(id) {
      this.data.images.src = this.data.images.src.filter(e => e.id != id);
      this.data.images.blob = this.data.images.blob.filter(
        item => item.id != id
      );
      this.$emit("onChange", { images: this.data.images.blob });
    }
  }
};
</script>

<style lang="scss" scoped>
.files__item {
  width: 100%;
  p {
    margin-bottom: 8px;
  }
}

.images {
  display: flex;
  flex-wrap: wrap;

  &__container {
    display: flex;
    align-items: center;
    max-width: 370px;
    margin: 0 auto;

    &_adaptive {
      flex-direction: column;
      width: 100%;

      .images__img {
        margin-right: 0;
      }

      .images__title {
        margin-top: 6px;
        text-align: center;
      }

      .images__content {
        width: 100%;
      }
    }
  }

  &__btn {
    border: 1px dashed #f07300;
    width: 100%;
    height: 120px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    transition: all 0.3s ease-out;
    cursor: pointer;

    &_adaptive {
      width: 120px;
    }

    &:hover {
      border: 1.04133px dashed #f07300c7;
      background-color: #f07300c7;
      color: #000;

      // .paintable-phone {
      //     fill: #f0730000 !important;
      // }

      // .paintable {
      //     stroke: #000 !important;
      // }

      .images__title {
        color: #fff;
      }

      .images__content {
        color: #fff;
      }
    }
  }

  &__item {
    position: relative;
    &_delete {
      position: absolute;
      right: 6px;
      top: 6px;
      color: #000;
    }
  }

  &__img {
    width: 60px;
    height: 60px;
    display: inline-block;
    margin-right: 22px;
  }

  &__content {
    width: calc(100% - 90px);
    line-height: 15px;
    font-size: 12px;
    color: #828282;
    transition: color 0.3s ease-out;

    &-text_adaptive {
      display: none;
    }
  }

  &__title {
    font-size: 14px;
    line-height: 18px;
    color: #f07300;
    display: block;
    transition: color 0.3s ease-out;
  }
}

@media (max-width: 768px) {
  .images__btn {
    order: 9999;
  }
}
</style>